const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.room_types/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.room_types/LIST_ROOM_TYPES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
